import _ from 'lodash'
import { dataFix } from '../../../common/dataFix'

export const formItemProps = (fieldProps, handleFormItemChange, req, _propHelp) => {

  const { caption, icon, id, key, propname, parents, placeholder, required, value, vit, subkey, parentkey, type, otype, disabled, readOnly, formItemType } = fieldProps
  const label = caption
  const vlps = { icon, id, label, parents, placeholder, required, value, vit, subkey, parentkey, disabled, readOnly }

  const _label = req ? caption + ' *' : caption

  vlps.placeholder = placeholder
  vlps.propname = propname
  vlps.className = (required) ? 'required' : ''
  vlps.key = key
  vlps.formItemType = formItemType
  vlps.label = _label
  vlps.help = _propHelp

  if (type) { vlps.type = type }
  if (otype) { vlps.otype = otype }

  const _vlps = dataFix.removeEmpties(vlps)
  _vlps.onChange = handleFormItemChange
  _vlps.value = (value === undefined) ? '' : value

  return _vlps

}